/**
 * Full-screen height for a sleek sub-page. #root already pads the host's
 * safe areas (`--page-safe-*`), so a plain `100svh` page overflowed by exactly
 * those insets and scrolled on a phone with a notch / home indicator.
 */
export const SLEEK_PAGE_MIN_HEIGHT = 'min-h-[calc(100svh-var(--page-safe-top,0px)-var(--page-safe-bottom,0px))]';

/** Exactly one screen, for a page laid out like the reveal (the Vault card):
 *  its card frame shrinks into a definite height instead of growing the page. */
export const SLEEK_PAGE_HEIGHT = 'h-[calc(100svh-var(--page-safe-top,0px)-var(--page-safe-bottom,0px))]';
